import type { BlockDefinition } from '../types';
import { sectoresSchema, type SectoresData } from './schema';
import { SectoresRenderer } from './Renderer.client';

export const sectoresBlock: BlockDefinition<SectoresData> = {
  meta: {
    type: 'sectores',
    label: 'Sectores con pills (v5)',
    description: 'Bloque de sectores con pills clicables que cambian el panel inferior (stats + casos).',
    category: 'content',
    icon: 'layout-dashboard',
  },
  schema: sectoresSchema,
  defaults: {
    eyebrow: '● Sectores · 14 verticales activas',
    title: 'Experiencia transversal.',
    titleHl: 'Foco en lo que mueve dinero real.',
    subtitle: '17 años trabajando con empresas de todos los tamaños. Profundidad sectorial donde más vale.',
    metaStats: [
      { value: '+120', label: 'operaciones' },
      { value: '14', label: 'sectores' },
      { value: '€115M', label: 'movilizados' },
    ],
    sectors: [
      {
        slug: 'saas',
        icon: '⚡',
        name: 'SaaS & Tech',
        count: '28',
        title: 'SaaS B2B, herramientas verticales y plataformas tech.',
        description: 'Acompañamos exits y rondas de growth de SaaS B2B, vertical software y plataformas data.',
        ops: '28',
        ticket: '€2,8M',
        max: '€18M',
        cases: [
          { tag: 'Venta · 2025', name: 'SaaS de gestión legal', meta: '€8M · Strategic buyer EU' },
          { tag: 'M&A · 2024', name: 'Vertical Fintech B2B', meta: '€15M · Cross-border' },
          { tag: 'Inversión · 2024', name: 'DevTools startup', meta: '€2M Seed · Lead investor' },
        ],
      },
      {
        slug: 'industria',
        icon: '⚙',
        name: 'Industria',
        count: '22',
        title: 'Fabricación industrial, transformación y procesos.',
        description: 'Operaciones M&A en industria, con especial foco en sucesión y consolidación de mercado.',
        ops: '22',
        ticket: '€4,2M',
        max: '€22M',
        cases: [
          { tag: 'Venta · 2024', name: 'Fabricante metalmecánico', meta: '€12M · Jubilación' },
          { tag: 'Compra · 2024', name: 'Grupo plásticos', meta: '€8M · Consolidación sector' },
          { tag: 'Venta · 2023', name: 'Componentes auto', meta: '€18M · Industrial buyer' },
        ],
      },
      {
        slug: 'hosteleria',
        icon: '◐',
        name: 'Hostelería',
        count: '14',
        title: 'Hostelería, restauración y grupos hoteleros.',
        description: 'Grupos hoteleros, cadenas de restauración y operadores de hostelería boutique.',
        ops: '14',
        ticket: '€2,1M',
        max: '€9M',
        cases: [
          { tag: 'Venta · 2024', name: 'Cadena restauración', meta: '€6M · Family office' },
          { tag: 'Venta · 2023', name: 'Hotel boutique', meta: '€4M · Group buyer' },
          { tag: 'Inversión · 2023', name: 'Concept restaurant', meta: '€1,5M Seed' },
        ],
      },
    ],
    ctaLabel: 'Ver casos del sector',
    ctaHref: '/portfolio',
  },
  fields: [
    { name: 'eyebrow', label: 'Eyebrow', type: 'text', max: 120 },
    { name: 'title', label: 'Título', type: 'text', required: true, max: 200 },
    { name: 'titleHl', label: 'Título highlight', type: 'text', max: 160 },
    { name: 'subtitle', label: 'Subtítulo', type: 'textarea', max: 500 },
    {
      name: 'metaStats',
      label: 'Stats cabecera',
      type: 'array',
      max: 4,
      itemFields: [
        { name: 'value', label: 'Valor', type: 'text', required: true, max: 40 },
        { name: 'label', label: 'Etiqueta', type: 'text', required: true, max: 120 },
      ],
    },
    {
      name: 'sectors',
      label: 'Sectores',
      type: 'array',
      max: 20,
      itemFields: [
        { name: 'slug', label: 'Slug', type: 'text', required: true, max: 40 },
        { name: 'icon', label: 'Icono (1 char)', type: 'text', required: true, max: 8 },
        { name: 'name', label: 'Nombre', type: 'text', required: true, max: 80 },
        { name: 'count', label: 'Contador (badge)', type: 'text', max: 8 },
        { name: 'label', label: 'Label panel', type: 'text', max: 160 },
        { name: 'title', label: 'Título panel', type: 'text', required: true, max: 200 },
        { name: 'description', label: 'Descripción', type: 'textarea', required: true, max: 600 },
        { name: 'ops', label: 'Operaciones (num)', type: 'text', required: true, max: 20 },
        { name: 'ticket', label: 'Ticket medio', type: 'text', required: true, max: 20 },
        { name: 'max', label: 'Op. mayor', type: 'text', required: true, max: 20 },
        {
          name: 'cases',
          label: 'Mini-casos',
          type: 'array',
          max: 4,
          itemFields: [
            { name: 'tag', label: 'Tag', type: 'text', required: true, max: 80 },
            { name: 'name', label: 'Nombre', type: 'text', required: true, max: 120 },
            { name: 'meta', label: 'Meta', type: 'text', required: true, max: 160 },
          ],
        },
      ],
    },
    { name: 'ctaLabel', label: 'Texto CTA', type: 'text', max: 80 },
    { name: 'ctaHref', label: 'URL CTA', type: 'url' },
  ],
  Renderer: SectoresRenderer,
};

export { sectoresSchema, SectoresRenderer };
export type { SectoresData };
